import normalizeFeatures from './utils/normalizeFeatures';

const types = {
  SET: 'features/SET',
  REPLACE: 'features/REPLACE',
  SET_ONE: 'features/SET_ONE',
};

export const set = (data) => ({
  type: types.SET,
  payload: { data },
});

export const replace = (data) => ({
  type: types.REPLACE,
  payload: { data },
});

export const setOne = (name, flag) => ({
  type: types.SET_ONE,
  payload: { name, flag },
});

const defaultState = {};

export default (state = defaultState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_ONE: {
      const { name, flag } = payload;

      return { ...state, ...normalizeFeatures({ [name]: flag }) };
    }

    case types.SET: {
      const { data } = payload;

      return { ...state, ...normalizeFeatures(data) };
    }

    case types.REPLACE: {
      const { data } = payload;

      return { ...normalizeFeatures(data) };
    }

    default: {
      return state;
    }
  }
};
